/* eslint-disable no-nested-ternary */
import { styled } from 'linaria/lib/react';
import React, { useState } from 'react';
import Image from 'next/image';
import { theme } from '@mtsbank/ui-kit';
import desktopWidgetPS from '@asserts/images/cyber/promo/widget/DesktopWidgetPS.png';
import tabletWidgetPS from '@asserts/images/cyber/promo/widget/TabletWidgetPS.png';
import mobileWidgetPS from '@asserts/images/cyber/promo/widget/MobileWidgetPS.png';
export const Widget = ({
  handleOpenWidget
}: {
  handleOpenWidget: () => void;
}) => {
  const [showButton] = useState<boolean>(false);
  return <WrapperButton showButton={showButton} onClick={handleOpenWidget} type="button">
      <MobileWrapper>
        <Image src={mobileWidgetPS} height={126} width={104} alt="Widget" />
      </MobileWrapper>
      <TabletWrapper>
        <Image src={tabletWidgetPS} height={137} width={106} alt="Widget" />
      </TabletWrapper>
      <DesktopWrapper>
        <Image src={desktopWidgetPS} height={175} width={136} alt="Widget" />
      </DesktopWrapper>
    </WrapperButton>;
};
const WrapperButton = /*#__PURE__*/styled("button")({
  name: "WrapperButton",
  class: "wzb2gw6"
});
const DesktopWrapper = /*#__PURE__*/styled("div")({
  name: "DesktopWrapper",
  class: "ddoly3h"
});
const TabletWrapper = /*#__PURE__*/styled("div")({
  name: "TabletWrapper",
  class: "tvbqfe6"
});
const MobileWrapper = /*#__PURE__*/styled("div")({
  name: "MobileWrapper",
  class: "mypzj1e"
});

require("./Widget.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./Widget.tsx");